<h6 class="border-bottom border-gray pb-2 mb-0">
  Services status
</h6>

<table class="table table-sm mt-2 table-borderless" *ngIf="services.length > 0">
  <thead>
  <tr>
    <th scope="col" class="">Service</th>
    <th scope="col">Host</th>
    <th scope="col" class="text-center">Status</th>
  </tr>
  </thead>
  <tbody>
  <ng-container *ngFor="let service of services">
    <tr>
      <th scope="row">{{service.label}}</th>
      <td class="text-muted">{{service.url}}</td>
      <td class="text-center">
        <i [ngClass]="getStatusClass(service)" class="fas fa-lg"></i>
      </td>
    </tr>
  </ng-container>
  <ng-container *ngFor="let blockedService of blockedServices">
    <tr>
      <th scope="row">{{blockedService.label}}</th>
      <td class="text-muted">{{blockedService.url}}</td>
      <td class="text-center">
        <i [ngClass]="getBlockedServiceStatusClass(blockedService)" class="fas fa-lg"></i>
      </td>
    </tr>
  </ng-container>
  </tbody>
</table>
<ng-container *ngIf="!isReady">
  <div>
    <app-spinner></app-spinner>
  </div>
</ng-container>
